import dayjs from "dayjs";

export interface DateTreeFilterItem {
  text: string;
  value: string;
  children?: DateTreeFilterItem[];
}

export const YEAR_FILTER_PREFIX = "year-";
export const MONTH_FILTER_PREFIX = "month-";

export const matchesDateTreeFilter = (
  date: dayjs.Dayjs | string,
  filterValue: string
): boolean => {
  const parsedDate = dayjs(date);

  if (filterValue.startsWith(YEAR_FILTER_PREFIX)) {
    const year = filterValue.slice(YEAR_FILTER_PREFIX.length);
    return parsedDate.format("YYYY") === year;
  }

  if (filterValue.startsWith(MONTH_FILTER_PREFIX)) {
    const yearMonth = filterValue.slice(MONTH_FILTER_PREFIX.length);
    return parsedDate.format("YYYY-MM") === yearMonth;
  }

  return false;
};

export const buildDateTreeFilters = (
  applicationDates: (string | null | undefined)[]
): DateTreeFilterItem[] => {
  const uniqueDates = Array.from(
    new Set(
      applicationDates
        .filter(Boolean)
        .map((date) => dayjs(date).format("YYYY-MM-DD"))
    )
  ).sort((dateA, dateB) => dayjs(dateA).valueOf() - dayjs(dateB).valueOf());

  const dateTree = new Map<string, Set<string>>();

  uniqueDates.forEach((date) => {
    const parsedDate = dayjs(date);
    const year = parsedDate.format("YYYY");
    const month = parsedDate.format("MM");

    if (!dateTree.has(year)) {
      dateTree.set(year, new Set());
    }
    dateTree.get(year)?.add(month);
  });

  return Array.from(dateTree.entries())
    .sort(([yearA], [yearB]) => yearA.localeCompare(yearB))
    .map(([year, months]) => ({
      text: year,
      value: `${YEAR_FILTER_PREFIX}${year}`,
      children: Array.from(months.values())
        .sort((monthA, monthB) => monthA.localeCompare(monthB))
        .map((month) => ({
          text: month,
          value: `${MONTH_FILTER_PREFIX}${year}-${month}`,
        })),
    }));
};
